export default "__VITE_ASSET__392f2174__"